var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container",
      staticStyle: { height: "100%", overflow: "auto" },
    },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("基本配置")]),
              ]),
              _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: {
                      path: "/staiff_info",
                      query: {
                        employeeId: this.employeeId,
                        judge: this.judge,
                        teamOrg: this.teamOrg,
                      },
                    },
                  },
                },
                [_c("div", { staticClass: "div3" }, [_vm._v("员工详情")])]
              ),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("权限管理")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("el-input", {
            staticStyle: { margin: "0 0px 20px" },
            attrs: { placeholder: "输入关键字进行搜索" },
            model: {
              value: _vm.filterText,
              callback: function ($$v) {
                _vm.filterText = $$v
              },
              expression: "filterText",
            },
          }),
          _c("el-tree", {
            ref: "tree",
            attrs: {
              data: _vm.data,
              "show-checkbox": "",
              "default-expand-all": "",
              "node-key": "id",
              "highlight-current": "",
              "filter-node-method": _vm.filterNode,
              props: _vm.defaultProps,
              "check-strictly": _vm.strictly,
              "default-expanded-keys": [""],
              "default-checked-keys": _vm.getArray,
            },
            on: { "check-change": _vm.checkChange },
          }),
          _c(
            "div",
            { staticClass: "backTop" },
            [
              [
                _c(
                  "el-backtop",
                  { attrs: { target: ".container", "visibility-height": 100 } },
                  [_vm._v(" 置顶 ")]
                ),
              ],
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveLimits } },
            [_vm._v("确定")]
          ),
          _c("el-button", { on: { click: _vm.resetChecked } }, [
            _vm._v("清空"),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }